import { observer } from 'mobx-react';

import './styles.scss';

import { useMedia, useStore } from 'shared/hooks';
import { PPDWidgetProductGroupsPricesList } from './components/PPDWidgetProductGroupsPricesList';
import { PPDWidgetProductGroupsPricesTable } from './components/PPDWidgetProductGroupsPricesTable';
import { PPDWidgetProductGroupsPricesModal } from './components/PPDWidgetProductGroupsPricesModal';
import { UserDashboardWidgetModel } from 'shared/models';

type PropsType = {
    widget: UserDashboardWidgetModel
};

export const PPDWidgetProductGroupsPrices = observer(({
    widget
}: PropsType) => {

    const store = useStore(() => ({
        isOpenModal: false,
    }));

    const { isMobileOrTablet } = useMedia();
    const visibleLimit = isMobileOrTablet ? 4 : 6;
    const visibleItems = widget.items.slice(0, visibleLimit);
    const hiddenItems = widget.items.slice(visibleLimit);
    const hasHiddenItems = hiddenItems.length > 0;

    return (
        <div className="ppd-widget-product-groups-prices">
            <h2 className="ppd-widget-product-groups-prices__title">{widget.name}</h2>

            {isMobileOrTablet ? (
                <PPDWidgetProductGroupsPricesList
                    items={visibleItems}
                    labels={widget.labels}
                />
            ) : (
                <PPDWidgetProductGroupsPricesTable
                    items={visibleItems}
                    labels={widget.labels}
                />
            )}

            {hasHiddenItems && (
                <>
                    <button
                        type="button"
                        className="ppd-widget-product-groups-prices__all-button"
                        onClick={() => store.set("isOpenModal", true)}
                    >
                        Все группы
                    </button>

                    <PPDWidgetProductGroupsPricesModal
                        title={widget.name}
                        items={widget.items}
                        labels={widget.labels}
                        isOpen={store.isOpenModal}
                        onClose={() => store.set("isOpenModal", false)}
                    />
                </>
            )}
        </div>
    )
});
